import { FamilyUnit } from '@zorro/clients';
import { createStore, useStore } from 'zustand';

export type EnrollmentAllowanceStorePlan = {
  planId: string;
  premium: number;
  carrierName?: string;
};

type EnrollmentAllowanceStore = {
  familyUnit: FamilyUnit;
  setFamilyUnit: (familyUnit: FamilyUnit) => void;
  numberOfDependents: 2 | 1 | null;
  setNumberOfDependents: (numberOfDependents: 2 | 1 | null) => void;
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  medicalPlans: EnrollmentAllowanceStorePlan[];
  setMedicalPlans: (plans: EnrollmentAllowanceStorePlan[]) => void;
  dentalPlans: EnrollmentAllowanceStorePlan[];
  setDentalPlans: (plans: EnrollmentAllowanceStorePlan[]) => void;
  visionPlans: EnrollmentAllowanceStorePlan[];
  setVisionPlans: (plans: EnrollmentAllowanceStorePlan[]) => void;
};

const enrollmentAllowanceStore = createStore<EnrollmentAllowanceStore>(
  (set) => ({
    familyUnit: FamilyUnit.EMPLOYEE_ONLY,
    setFamilyUnit: (familyUnit) => set({ familyUnit }),
    numberOfDependents: null,
    setNumberOfDependents: (numberOfDependents) => set({ numberOfDependents }),
    isDirty: false,
    setIsDirty: (isDirty) => set({ isDirty }),
    medicalPlans: [],
    setMedicalPlans: (medicalPlans) => set({ medicalPlans }),
    dentalPlans: [],
    setDentalPlans: (dentalPlans) => set({ dentalPlans }),
    visionPlans: [],
    setVisionPlans: (visionPlans) => set({ visionPlans }),
  })
);

export function useEnrollmentAllowanceStore<T>(
  selector: (state: EnrollmentAllowanceStore) => T
): T {
  return useStore(enrollmentAllowanceStore, selector);
}
